import { ScoreDataQuery } from '../ScoreData.generated';

export interface ScoreData {
	calculation_date: string;
	unit_id: string | null;
	environment: string | null;
	score: number | null;
	timeframe_days: number | null;
}

export interface ScoreDataResult {
	scores: ScoreData[];
	lastUpdatedAt: number;
}

export const transformScoreDataResults = (rawResults: ScoreDataQuery): ScoreDataResult => {
	const rawScores =
		rawResults?.score_web_products?.filter(
			(score): score is NonNullable<typeof score> => score !== null
		) ?? [];

	const scoreMap = new Map<string, ScoreData>();

	rawScores.forEach((score) => {
		const convertedScore =
			score.score !== null && score.score !== undefined ? Math.round(score.score * 100) : null;

		const scoreData: ScoreData = {
			calculation_date: score.calculation_date ?? '',
			unit_id: score.unit_id ?? null,
			environment: score.environment ?? null,
			score: convertedScore,
			timeframe_days: score.timeframe_days ?? null
		};

		const dateKey = score.calculation_date ?? '';
		scoreMap.set(dateKey, scoreData);
	});

	// Convert map to array and sort by date
	const scores = Array.from(scoreMap.values()).sort(
		(a, b) => new Date(a.calculation_date).getTime() - new Date(b.calculation_date).getTime()
	);

	const lastUpdatedAt = rawScores.reduce((max, score) => {
		if (!score.created_at) {
			return max;
		}
		const timestamp = new Date(score.created_at).getTime();
		return timestamp > max ? timestamp : max;
	}, 0);

	return {
		scores,
		lastUpdatedAt
	};
};
